export default __webpack_public_path__ + "463d2ad783b51a06119cc7e309dd865b.png";